import React from 'react'
import Dashboard from '../../Screens/Cashier/Dashboard'
import NewSale from '../../Screens/Cashier/NewSale'
import Products from '../../Screens/Cashier/Products'
import Quotations from '../../Screens/Cashier/Quotations'
import RecentReceipts from '../../Screens/Cashier/RecentReceipts'
import Reports from '../../Screens/Cashier/Reports'
import Profile from '../../Screens/Cashier/Profile'
import Checkout from '../../Screens/Cashier/Checkout'
import PrintBarcodesCashier from '../../Screens/Cashier/PrintBarcodesCashier'
import Layby from '../../Screens/Cashier/Layby'

const Main = ({ activeScreen, isFirstLogin, onNavigate }) => {
  const renderScreen = () => {
    // If first login, only allow profile screen
    if (isFirstLogin && activeScreen !== 'profile') {
      return <Profile />
    }

    switch (activeScreen) {
      case 'dashboard':
        return <Dashboard />
      case 'new-sale':
        return <NewSale onNavigate={onNavigate} />
      case 'products':
        return <Products />
      case 'print-barcodes':
        return <PrintBarcodesCashier />
      case 'quotation':
        return <Quotations />
      case 'recent-receipts':
        return <RecentReceipts />
      case 'layby':
        return <Layby />
      case 'reports':
        return <Reports />
      case 'profile':
        return <Profile />
      case 'checkout':
        return <Checkout onNavigate={onNavigate} />
      default:
        return <NewSale onNavigate={onNavigate} />
    }
  }

  return (
    <main id="main" className="main">
      {renderScreen()}
    </main>
  )
}

export default Main
